import { constructLocation, flattenEstablishmentContacts } from "@/composables/clientPickerShared";

export function findEstablishment({ contactInfos, establishment_id = null }) {
	if (!establishment_id) {
		return { establishmentId: null, establishment: null };
	}

	const establishment = contactInfos?.establishments?.find(e => e.id === establishment_id) ?? null;
	return { establishmentId: establishment_id, establishment };
}

export function findContact({ contactInfos, email = null }) {
	const contacts = flattenEstablishmentContacts(contactInfos?.establishments ?? []);
	if (!email) {
		return null;
	}
	return contacts.find(c => c.email === email) ?? null;
}

export function toDeliveryPayload({ establishment, contact }) {
	return {
		establishment_id: establishment?.id ?? null,
		name: establishment?.name ?? null,
		address: establishment?.place?.exported_address?.trim() || null,
		address2: establishment?.place?.route2 || null,
		location: constructLocation(establishment?.place) || null,
		email: contact?.email || null,
		phone: contact?.phone || null,
		details:
			[contact?.name?.trim(), contact?.job?.trim()].filter(info => info && info.length > 0).join("&nbsp;") || null
	};
}

export function deliveryToEstablishment({ establishment_id, name, address, address2, location }) {
	if (!establishment_id && !name && !address && !address2 && !location) return null;

	return {
		id: establishment_id ?? -1,
		name: name ?? null,
		place: {
			exported_address: address ?? "",
			route: address ?? "",
			route2: address2 ?? "",
			postal_code: "",
			locality: location ?? "",
			country: ""
		}
	};
}

export function deliveryToContact({ email, phone, details, establishment_id, establishments = [] }) {
	if (!email && !phone && !details) return null;

	const establishment = establishments.find(e => e.id === establishment_id) ?? null;
	return {
		id: -1,
		email: email ?? "",
		phone: phone ?? "",
		name: details ?? "",
		job: "",
		establishment: {
			id: establishment?.id ?? establishment_id ?? null,
			name: establishment?.name ?? ""
		}
	};
}
